import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { API_CONSTANT } from '../../services/api.constant';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { CALENDAR_LOCALE } from '../../services/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-customer-request',
  templateUrl: './customer-request.component.html',
  styleUrls: ['./customer-request.component.scss']
})
export class CustomerRequestComponent implements OnInit {
  language = localStorage.getItem('lang') || 'en';
  refreshDropdown = false;
  modal: any;
  countries: any[];
  confirmLoading: boolean = false;
  buyerRequestForm: FormGroup;
  showError: boolean = false;
  loading: boolean = false;
  plusKeyPressed: boolean = false;
  calendarLocale = CALENDAR_LOCALE.EN;
  constructor(
    private formBuilder: FormBuilder,
    private httpClient: HttpClient,
    private modalService: NgbModal,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
  ) {
    if (!environment.enabledCustomerRequest) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    this.translate.onLangChange.subscribe(() => {
      this.translateDropdown();
    });
    this.createBuyerRequestForm();
    this.loadCountries();
  }

  translateDropdown(): void {
    this.refreshDropdown = true;
    setTimeout(() => {
      this.refreshDropdown = false;
    }, 1);
  }

  changeLanguage() {
    this.translate.use(this.language);
    localStorage.setItem('lang', this.language);
  }

  createBuyerRequestForm() {
    this.buyerRequestForm = this.formBuilder.group({
      type: ['hotel', Validators.required],
      abbNo: [null, Validators.required],
      receiptIssueDate: [null, Validators.required],
      name: [null, Validators.required],
      taxID: [null, [this.validateTaxId, Validators.required]],
      branchCode: [null],
      branchName: [null],
      address: [null, Validators.required],
      postcode: [null, this.validatePostCode],
      country: [221, Validators.required],
      email: [null, [this.validateEmail, Validators.required]],
      ccEmail: [null],
      phoneNumber: [null, [Validators.required]],
      amount: ['0.00', [Validators.required]]
    });
  }

  validateTaxId(control: AbstractControl) {
    if (
      control.value && Boolean(control.value.match(/^[0-9]{13}$/g))
    ) {
      return null;
    }
    return { taxIDInvalid: true };
  }

  validateEmail(control: AbstractControl): { [key: string]: any } | null {
    if (control.value) {
      return Validators.email(control);
    }
    return null;
  }

  validatePostCode(control: AbstractControl): { [key: string]: any } | null {
    if (control.value && Boolean(control.value.match(/^[0-9]{5}$/g))) {
      return null;
    }
    return {'postalCodeInvalid': true};
  }

  loadCountries() {
    this.httpClient.get(API_CONSTANT.country).subscribe(
      (res: any) => {
        this.countries = res;
      }
    );
  }

  get countryCode(): string {
    return this.form.country.value;
  }

  countryChange(event) {
    if (event.country_code === 'TH') {
      this.form.postcode.setValidators([this.validatePostCode]);
      this.form.taxID.setValidators([this.validateTaxId, Validators.required]);
    } else {
      this.form.postcode.setValidators([]);
      this.form.taxID.setValidators([Validators.required]);
    }
    this.form.postcode.updateValueAndValidity();
    this.form.taxID.updateValueAndValidity();
  }

  alertSubmitSuccess() {
    Swal.fire({
      title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-SUCCESS'),
      html: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-SUCCESS'),
      type: 'success',
      confirmButtonColor: '#02008a',
      confirmButtonText: this.translate.instant('COMMON.CLOSE'),
      customClass: {
        title: 'custom-title'
      },
      width: '600px'
    });
  }

  alertSubmitFailure() {
    Swal.fire({
      title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-FAILED'),
      text: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-FAILED'),
      type: 'error',
      confirmButtonColor: '#02008a',
      confirmButtonText: this.translate.instant('COMMON.CLOSE'),
      customClass: {
        title: 'text-red'
      }
    });
  }

  formatPhoneNumber(event :any){
    const valueInput = event.target.value
    const checkPlus = valueInput.includes("+")
    if(checkPlus){
      const textValue = valueInput.replace("+","")
      event.target.value = "+"+textValue
      this.cdRef.detectChanges();
    }
    else{
      this.plusKeyPressed = false;
    }

  }

  charValidate(event:any){
    if ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 43 && !this.plusKeyPressed)) {
      if (event.charCode == 43) {
        this.plusKeyPressed = true;
      }
      return true;
    }
    return false;
  }

  confirmation(modalContent) {
    this.showError = false;
    if (this.buyerRequestForm.invalid) {
      this.showError = true;
      return;
    }
    this.modal = this.modalService.open(modalContent, {centered: true, size: 'lg'});
  }

  closeModal() {
    if (this.modal) {
      this.modal.close();
    }
  }

  submit() {
    this.loading = true;
    const data = {
      room_type: this.form.type.value,
      confirmation_no: '',
      abb_no: this.form.abbNo.value,
      receipt_dt: this.form.receiptIssueDate.value,
      buyer_name: this.form.name.value,
      tax_id: this.form.taxID.value,
      branch_code: this.form.branchCode.value,
      branch_name: this.form.branchName.value,
      address: this.form.address.value,
      postal_code: this.form.postcode.value,
      country: this.form.country.value,
      email: this.form.email.value,
      cc_email: this.form.ccEmail.value,
      phone_number: this.form.phoneNumber.value,
      amount: this.form.amount.value,
    };
    this.httpClient.post(API_CONSTANT.document_request, data)
      .pipe(
        finalize(() => {
          this.closeModal();
          this.loading = false;
          this.showError = false;
        })
      )
      .subscribe(
        () => {
          this.buyerRequestForm.reset();
          this.form.type.setValue('hotel');
          this.alertSubmitSuccess();
        },
        () => {
          this.alertSubmitFailure();
        }
      );
  }

  taxIDChange(event: any): void {
    const taxID = event.target.value;
    if (!taxID || taxID.length !== 13) {
      return;
    }
    const params = {
      tax_id: taxID
    };
    this.httpClient.get(`${API_CONSTANT.buyer}external/`, {params: params}).subscribe(
      (result) => {
        this.buyerRequestForm.patchValue({
          name: result['name'],
          address: result['address'],
          country: result['country_id'],
          postcode: result['post_code'],
        });
        this.form.postcode.setValidators([this.validatePostCode]);
        this.form.postcode.updateValueAndValidity();
      },
    );
  }

  get form(): { [key: string]: AbstractControl } {
    return this.buyerRequestForm.controls;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.component.ts